<template>
  <a-modal :open="open" @cancel="closeForm">
    <h2>{{ currentGroup ? 'Редактирование' : 'Создание' }} группы</h2>
    <a-divider style="margin: 16px 0"/>
    <span>Название группы</span>
    <a-input v-model:value="groupForm.name"/>
    <span v-if="statusError.groupName">
        Ввведите название группы
    </span>

    <div class="select-users-wrapper">
      <span>Действующие сотрудники</span>
      <a-select
          v-model:value="groupForm.users"
          show-search
          allow-clear
          mode="multiple"
          :placeholder="'Не выбрано'"
          :not-found-content="usersLoading ? 'Поиск…' : 'Нет данных'"
          :loading="usersLoading"
          :filter-option="false"
          :options="userOptions"
          @search="debouncedSearch"
          @clear="clearUsers"
          class="select-users"
          :show-arrow="true"
      />
    </div>

    <template #footer>
      <a-divider/>
      <div class="action-buttons">
        <a-row justify="end" :gutter="8">
          <a-col>
            <a-button class="secondary-button" @click="closeForm">Отменить</a-button>
          </a-col>
          <a-col>
            <a-button class="primary-button" :loading="modalActionLoading" @click="handleGroupEdit">
              {{ currentGroup ? 'Сохранить' : 'Создать'}}
            </a-button>
          </a-col>
        </a-row>
      </div>
    </template>
  </a-modal>
</template>

<script>
import {message} from "ant-design-vue";
import {useStore} from "vuex";
import {onBeforeMount, reactive, ref} from "@vue/runtime-core";
import debounce from "@/mixins/debounce";
import {computed} from "@vue/reactivity";

export default {
  props: {
    open: Boolean,
    currentGroup: Object,
    name: String,
  },
  emits: ['submitted', 'close'],
  setup(props, context) {
    const store = useStore();
    const modalActionLoading = ref(false);
    const groupToCopyIn = ref();
    const foundUsers = computed(() => store.state.users.foundUsers);

    const groupForm = reactive({
      name: props?.name ?? '',
      users: props.currentGroup ? props.currentGroup?.users?.map((user) => user.id) : [],
    });

    const statusError = reactive({
      groupName: false,
    });

    const usersLoading = ref(false);
    const userOptions = ref([]);

    let currentSearchRequest = ref(0);

    const searchForUsers = async (query) => {
      fillUsers();

      if (!query || query.length < 3) return;

      let requestNumber = ++currentSearchRequest.value;
      usersLoading.value = true;

      userOptions.value = [];

      store.dispatch('users/searchByName', query).then(() => {
        if (requestNumber !== currentSearchRequest.value) return;

        const uniqueNew = foundUsers.value
            .filter(u => !userOptions.value.some((opt) => {
              return u.id === opt.value;
            }))
            .map(u => ({
              value: u.id,
              label: `${u.name} (${u.email})`,
            }));

        userOptions.value.push(...uniqueNew);
        usersLoading.value = false
      });
    }

    const debouncedSearch = debounce(searchForUsers, 350);

    const clearUsers = () => {
      fillUsers();
    }

    const fillUsers = () => {
      if (props.currentGroup) {
        userOptions.value =  props.currentGroup?.users?.map(user => {
          return {
            value: user.id,
            label: `${user.name} (${user.email})`,
          }
        });
      }
    }

    const handleGroupEdit = () => {
      if (!groupForm.name) {
        statusError.groupName = true;
        modalActionLoading.value = false;
        return;
      } else {
        statusError.groupName = false;
      }

      modalActionLoading.value = true;

      if (props.currentGroup) {
        store.dispatch('group/updateGroup', {group: {...groupForm}, id: props.currentGroup.id}).then(() => {
          store.dispatch("group/getGroup", props.currentGroup.id);
          message.success('Данные обновлены');
          store.dispatch('users/clearFoundUsers');
          context.emit('submitted')
        }).finally(() => modalActionLoading.value = false);
      } else {
        store.dispatch('group/createGroup', {...groupForm}).then(() => {
          message.success('Группа создана');
          context.emit('submitted')
        }).finally(() => {
          modalActionLoading.value = false;
        });
      }


    }

    const closeForm = () => {
      context.emit('close');
    }

    onBeforeMount(() => {
      fillUsers();
    });

    return {
      groupToCopyIn,
      modalActionLoading,
      closeForm,
      groupForm,
      statusError,
      handleGroupEdit,
      searchForUsers,
      usersLoading,
      debouncedSearch,
      userOptions,
      clearUsers
    }
  }
}
</script>

<style scoped lang="scss">
.select-users-wrapper {
  margin-top: 15px;
  display: flex;
  flex-direction: column;
  row-gap: 5px;
}

.select-users {
  width: 100%;
}
</style>